export enum UserRole {
  student = 'STUDENT',
  teacher = 'TEACHER',
  admin = 'ADMIN',
  coordinator = 'COORDINATOR_ONMAT',
}

export enum AuthMessageError {
  SCHOOL_NOT_EXISTS = 'SCHOOL_NOT_EXISTS',
  SCHOOL_HAS_NOT_AVAILABLE_LICENSES = 'SCHOOL_HAS_NOT_AVAILABLE_LICENSES',
  TEACHER_HAS_NOT_GROUPS = 'TEACHER_HAS_NOT_GROUPS',
  STUDENT_NOT_IN_GROUP = 'STUDENT_NOT_IN_GROUP',
  WRONG_REGION = 'WRONG_REGION',
  USER_HAS_NO_ROLES = 'USER_HAS_NO_ROLES',
  TEACHER_NOT_IN_GROUP = 'TEACHER_NOT_IN_GROUP',
  INVALID_LOCAL_DATETIME = 'INVALID_LOCAL_DATETIME',
  INVALID_TOKEN = 'INVALID_TOKEN',
  CLOSE_SESSION = 'CLOSE_SESSION',
}

export interface ErrorCode {
  error: {
    errorCode: string;
  };
}

export enum AlertMessageError {
  ACTIVITY_NOT_FOUND = 'ACTIVITY_NOT_FOUND',
  RUBRIC_CONFIGURATION_NOT_FOUND = 'RUBRIC_CONFIGURATION_NOT_FOUND',
  EXERCISE_NOT_FOUND = 'EXERCISE_NOT_FOUND',
  ACTIVITY_FEATURE_NOT_FOUND = 'ACTIVITY_FEATURE_NOT_FOUND',
  MULTIPLE_ANSWER_NOT_FOUND = 'MULTIPLE_ANSWER_NOT_FOUND',
  GROUP_NOT_FOUND = 'GROUP_NOT_FOUND',
  SCHOOL_NOT_FOUND = 'SCHOOL_NOT_FOUND',
  STUDENT_ANSWERS_CREATE_ERROR = 'STUDENT_ANSWERS_CREATE_ERROR',
  STUDENT_FEATURE_NOT_FOUND = 'STUDENT_FEATURE_NOT_FOUND',
  TEACHER_NOT_FOUND = 'TEACHER_NOT_FOUND',
  STEP_NOT_FOUND = 'STEP_NOT_FOUND',
  INVALID_ACTIVITY_STATE = 'INVALID_ACTIVITY_STATE',
}
